var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#9B7BD0",
    fillOpacity: 0.23
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0133,
    cy: 75.9998,
    r: 70.1539,
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0397,
    cy: 72.4918,
    r: 58.4616,
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1935,
    cy: 66.6456,
    r: 52.6154,
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1208,
    cy: 66.6455,
    r: 46.7693,
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.2879,
    cy: 66.6452,
    rx: 35.0769,
    ry: 40.9231,
    fill: "#9B7BD0",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6268,
    cy: 64.6961,
    rx: 23.3846,
    ry: 27.2821,
    fill: "#9B7BD0",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2023_23727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.1244,
    cy: 64.3087,
    r: 17.5385,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2023_23727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.4814,
    cy: 64.3085,
    r: 11.6923,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2023_23727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.902,
    cy: 63.7238,
    r: 8.76924,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2023_23727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.4946,
    cy: 64.3083,
    r: 5.84616,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2023_23727",
    x: 34.5859,
    y: 42.7703,
    width: 43.0781,
    height: 43.0769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2023_23727",
    x: 42.7891,
    y: 48.6162,
    width: 31.3828,
    height: 31.3846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2023_23727",
    x: 45.1328,
    y: 50.9546,
    width: 25.5391,
    height: 25.5385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2023_23727",
    x: 48.6484,
    y: 54.4622,
    width: 19.6914,
    height: 19.6923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkcircle);
export default __webpack_public_path__ + "static/media/Pink circle.e71c555d1d7e28fa3149adf2833f7109.svg";
export { ForwardRef as ReactComponent };